import {Link} from "react-router-dom";
import Loader2 from "../../Components/Loader2";
import {useGetCategoriesQuery} from "../../RTK/Slices/Slices/apiSliceMeat";
import {DEFAULT_IMAGE_URL} from "../../config/apiConfig";

function Categories() {
    const {data: Categories, isErrorBrands, isLoadingBrands} = useGetCategoriesQuery();
    const dataCategories = Categories?.data ?? [];

    if (isLoadingBrands) return <Loader2 />;
    if (isErrorBrands) return null;

    return (
        <div className="bg-gray-100 py-5 md:py-10">
            {/* Grid: موبايل 3 كولومن، تابلت 5، ديسكتوب 7 */}
            <div className="container">
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-3 md:gap-6">
                    {dataCategories.map((Categorie, i) => (
                        <Link
                            key={Categorie?.category_id}
                            to={`ProductsCategorie/${Categorie?.category_id}`}
                            className="group"
                            style={{
                                /* انيميشن دخول متتابع لكل كارت */
                                animation: `catFadeUp 0.4s ease both`,
                                animationDelay: `${Math.min(i * 0.05, 0.5)}s`,
                            }}
                        >
                            <div
                                className="rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 active:scale-95 bg-white"
                                style={{
                                    backgroundColor: "var(--category-card-bg-color, #ffffff)",
                                    border: "var(--category-card-border, none)",
                                }}
                            >
                                {/* صورة التصنيف */}
                                <div className="w-full aspect-square overflow-hidden bg-gray-50 flex items-center justify-center">
                                    <img
                                        src={Categorie?.image_url || DEFAULT_IMAGE_URL}
                                        alt={Categorie?.category_name}
                                        onError={(e) => { e.target.src = DEFAULT_IMAGE_URL; }}
                                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                                        loading="lazy"
                                    />
                                </div>
                                {/* الاسم */}
                                <div className="px-1 py-2 text-center">
                                    <h3 className="text-xs md:text-sm font-semibold text-gray-800 leading-tight line-clamp-2">
                                        {Categorie?.category_name}
                                    </h3>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>

            {/* keyframes لانيميشن الدخول */}
            <style>{`
                @keyframes catFadeUp {
                    from { opacity: 0; transform: translateY(18px); }
                    to   { opacity: 1; transform: translateY(0);    }
                }
            `}</style>
        </div>
    );
}

export default Categories;
